import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { theme } from 'utils/style'

const StyledSpan = styled.span`
  background-color: ${({ colorRed }) =>
    colorRed ? theme('colors.danger') : theme('colors.grayscale.light')};
  border-radius: 5px;
  font-size: 12px;
  color: ${theme('colors.white')};
  padding: 0 5px;
  position: relative;
  top: 5px;
`

const StyledInput = styled.input`
  outline: 0;
`

const TextInputWithCharactersLeft = props => {
  const { maxLength, value } = props
  const charactersLeft = Math.max(maxLength - (value.length || 0), 0)

  return (
    <>
      <StyledInput {...props} />
      <StyledSpan colorRed={charactersLeft === 0}>{charactersLeft}</StyledSpan>
    </>
  )
}

TextInputWithCharactersLeft.propTypes = {
  maxLength: PropTypes.string,
  value: PropTypes.string,
}

export default TextInputWithCharactersLeft
